import { gql } from '@apollo/client';
import RMA_DEVICES_FRAGMENT from '../fragments/rmaDevices';

const RMA_DEVICES_QUERY = gql`
  query rmaDevices($filter: CallCenterDeviceFilterInput, $limit: Int) {
    callCenterDevices(filter: $filter, limit: $limit) {
      ...RmaDeviceFields
    }
  }

  ${RMA_DEVICES_FRAGMENT}
`;

export default RMA_DEVICES_QUERY;
